import { remoteCall } from "../../../remoteservice/RemoteService"
const postMethods = async (url, data) => {
    const res = await remoteCall(url, { params: null, data: data, loadingState: 0 }, true)
    return res;
}
const listMenu = async (url, params) => {
    const res = await remoteCall(url, { params: params, data: null, loadingState: 0 }, true)
    return res;
}
const getMenu = async (url, key) => {
    const urls = url + key
    const res = await remoteCall(urls, { params: {}, data: null, loadingState: 0 }, true)
    return res;
}
const getrole = async (url, key) => {
    const urls = url + key
    const res = await remoteCall(urls, { params: null, data: {}, loadingState: 0 }, true)
    return res;
}
const addMenu = async (url, data) => {
    let datas = data
    datas.priviledgeScope = '2'
    datas.pcode = 'ebk'
    datas.systemId = 136
    const res = await remoteCall(url, { params: null, data: data, loadingState: 0 }, true)
    return res;
}
const putMenu = async (url, data) => {
    const res = await remoteCall(url, { params: null, data: data, type: 'put', loadingState: 3 }, true)
    return res;
}
const delMenu = async (url) => {
    const res = await remoteCall(url, { params: null, data: null, type: 'delete', loadingState: 3 }, true)
    return res;
}
class MenuApi {
    static addMenu(query) {
        return addMenu('/dev-api/system/menus?r=' + Math.random(), query)
    }
    static listMenu(query) {
        query.pcode = 'ebk'
        query.systemId = 136
        return listMenu('/dev-api/system/menus/list', query)
    }
    static getMenu(query) {
        return getMenu('/dev-api/system/menus/', query)
    }
    static delMenu(query) {
        return delMenu('/dev-api/system/menus/' + query)
    }
    static updateMenu(query) {
        return putMenu('/dev-api/system/menus?r=' + Math.random(), query)
    }
    static menusTreeselect() {
        return listMenu('/dev-api/system/menus/treeselect', {})
    }
    static roleMenuTreeselect(id) {
        return getMenu('/dev-api/system/menus/roleMenuTreeselect/', id)
    }
    static rolePerselect(data) {
        return postMethods('/dev-api/system/sysRoleButton/selectList', data)
    }
    static roleDataTreeselect(id) {
        return getrole('/dev-api/system/datascope/selectByRoleId/', id)
    }
    static getPermission() {
        return postMethods('/dev-api/system/sysButton/getPermission', {})
    }
    static getModelEntit(params) {
        // ?needScopeMgt=1
        return listMenu('/dev-api/model/model-entity/list',params)
    }
    static insertsysButton(params) {
        return postMethods('/dev-api/system/sysButton/insert?r=' + Math.random(),params)
    }

    static getPerList() {
        return postMethods('/dev-api/system/sysButton/selectList', {pcode:''})
    }
}
export default MenuApi